import { Injectable } from '@angular/core';
import {LocalStorageService} from "./local-storage.service";
import {Observable} from "rxjs";
import { AuthMode, IdValidationRequestBody, IdValidationResponse } from '../common/classes';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UtilsService } from './utils.service';
import { map, switchMap } from 'rxjs/operators';
import { get } from 'lodash';
import { CustomCookieService } from './custom-cookie.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {

  constructor(
    private customCookieService: CustomCookieService,
    private localStorageService: LocalStorageService,
    private http: HttpClient,
    private utilsService: UtilsService
    ) { }

  public logIn(): Observable<any> {
    return this.http.get('/secure/login', {withCredentials:true})
  }

  

  public signOut(): Observable<any> {
    this.customCookieService.clearData();
    this.localStorageService.clearData();
    return this.http.get('/ui/api/secure/logout', {withCredentials:true})
  }

  public getAuthViewMode(): Observable<AuthMode> {
    return new Observable((subscriber) => {
      subscriber.next(this.localStorageService.getData('mode'))
      subscriber.complete();
    });
  }
  
  public validateClientId(reuqestBody:IdValidationRequestBody): Observable<any> {
    return this.http.post<IdValidationResponse>('/ui/api/bmw/validate', reuqestBody, {withCredentials:true})
  }
  public _getMockJwtToken() {
    return this.http.get('/ui/api/secure/mockjwt', {withCredentials:true})
  }
  public _simulateLogin(jwtToken: string) {
    const headers = new HttpHeaders()
        .set('content-type', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
        .set('x-customheader', jwtToken)
      return this.http.get('/ui/api/secure/login', {withCredentials:true, headers}).pipe(map((item)=>{
      this.customCookieService.saveData('mtnList', get(item,'[0].mtnList'))
      this.customCookieService.saveData('billAccountNumber', get(item,'[0].billAccountNumber'))
      return item;
    }))
  }
}
